import { convertTime } from '@mail-core/std';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { unlimitedDocsFakedoorConfig, unlimitedDocumentsLogger } from 'reactApp/appHelpers/featuresHelpers/features/unlimitedDocuments';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { getUnlimitedDocumentsBannerStoreValue } from 'reactApp/modules/unlimitedDocuments/unlimitedDocuments.const';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export const useUnlimitedDocumentsBanner = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const storage = useSelector(getCurrentStorage);
    const { isHome } = getStorage(storage);

    const storeValue = useMemo(() => getUnlimitedDocumentsBannerStoreValue(), []);

    const conditions = {
        isNotHome: !isHome,
        isPaidUser,
        isCompeleted: storeValue?.state,
        maxShowCount: storeValue?.counts?.show >= (unlimitedDocsFakedoorConfig.leftBlockBanner?.showLimit || 0),
        intervalLimit:
            convertTime(Date.now() - storeValue?.time, 'ms', 'second') < (unlimitedDocsFakedoorConfig.leftBlockBanner?.showInterval || 0),
        isFeatureDisabled: !unlimitedDocsFakedoorConfig.leftBlockBanner.enable,
    };

    if (Object.values(conditions).includes(true)) {
        unlimitedDocumentsLogger.info('unlim-docs-banner init failure', conditions);
        return { show: false };
    }

    return { show: true };
};
